class CreateFeedback {
  constructor(AccountingSessionID, Rate, Description) {
    this.AccountingSessionID = AccountingSessionID;
    this.Rate = Rate;
    this.Description = Description;
  }
}

export default CreateFeedback;